// Copyright (c) 2016 Deere & Company

import QuestionablePartReport from '../../../reports/questionable-part-search/state-connector';

export default {
    component: QuestionablePartReport,
    name: 'QUESTIONABLE_PART',
    path: 'questionable-part'
};



// WEBPACK FOOTER //
// ./src/routes/tcsm/reports/questionable-part-search.js